import React, { useState } from "react";
import styles from "../stylesER.module.scss";

export const BuildingCommissionModal = ({
  isOpen,
  monthIndex,
  mesesCompletos,
  comisiones,
  comisionesFijas = [],
  getMoneda,
  formatCurrency,
  onClose,
}) => {
  const [variableOpen, setVariableOpen] = useState(false);
  const [fijoOpen, setFijoOpen] = useState(false);

  if (!isOpen || monthIndex === null) return null;

  const totalVariable = comisiones.reduce((sum, curr) => sum + curr.totalComision, 0);
  const totalFijo = comisionesFijas.reduce((sum, curr) => sum + curr.montoLocal, 0);
  const totalGeneral = totalVariable + totalFijo;
  const moneda = getMoneda();

  const toggleStyle = {
    cursor: "pointer",
    userSelect: "none",
  };

  const arrowStyle = (open) => ({
    display: "inline-block",
    transition: "transform 0.2s",
    transform: open ? "rotate(90deg)" : "rotate(0deg)",
    marginRight: 6,
    fontSize: 12,
  });

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3>Detalle comisión edificios - {mesesCompletos[monthIndex]}</h3>
        <table className={styles.modalTable}>
          <thead>
            <tr>
              <th className={styles.buildingFacturaHeader}>Concepto</th>
              <th className={styles.buildingClienteHeader}>Detalle</th>
              <th className={styles.buildingComisionHeader}>Comisión {moneda}</th>
            </tr>
          </thead>
          <tbody>
            {/* Fila resumen Variable */}
            {comisiones.length > 0 && (
              <tr className={styles.modalTotal} style={toggleStyle} onClick={() => setVariableOpen(!variableOpen)}>
                <td colSpan="2" style={{ textAlign: "left" }}>
                  <strong>
                    <span style={arrowStyle(variableOpen)}>&#9654;</span>
                    Comisión variable ({comisiones.length} facturas)
                  </strong>
                </td>
                <td className={styles.buildingComisionData}>
                  <strong>{formatCurrency(totalVariable)}</strong>
                </td>
              </tr>
            )}
            {/* Detalle Variable (colapsable) */}
            {variableOpen &&
              comisiones.map((comision, i) => (
                <tr key={i} style={{ backgroundColor: "#f8f9fa" }}>
                  <td className={styles.buildingFacturaData} style={{ paddingLeft: 24 }}>
                    {comision.facturanumero}
                  </td>
                  <td className={styles.buildingClienteData}>{comision.cliente}</td>
                  <td className={styles.buildingComisionData}>
                    {comision.sinEdificios ? (
                      <span style={{ color: "#dc3545", fontStyle: "italic", fontSize: 13 }}>
                        Sin edificios asignados
                      </span>
                    ) : comision.soloFijos ? (
                      <span style={{ color: "#6c757d", fontStyle: "italic", fontSize: 13 }}>
                        Involucra únicamente edificios comisión fija
                      </span>
                    ) : (
                      formatCurrency(comision.totalComision)
                    )}
                  </td>
                </tr>
              ))}
            {/* Fila resumen Fijo */}
            {comisionesFijas.length > 0 && (
              <tr className={styles.modalTotal} style={toggleStyle} onClick={() => setFijoOpen(!fijoOpen)}>
                <td colSpan="2" style={{ textAlign: "left" }}>
                  <strong>
                    <span style={arrowStyle(fijoOpen)}>&#9654;</span>
                    Comisión fija ({comisionesFijas.length} edificios)
                  </strong>
                </td>
                <td className={styles.buildingComisionData}>
                  <strong>{formatCurrency(totalFijo)}</strong>
                </td>
              </tr>
            )}
            {/* Detalle Fijo (colapsable) */}
            {fijoOpen &&
              comisionesFijas.map((fija, i) => (
                <tr key={`fija-${i}`} style={{ backgroundColor: "#f8f9fa" }}>
                  <td className={styles.buildingFacturaData} style={{ paddingLeft: 24 }}>
                    Fijo
                  </td>
                  <td className={styles.buildingClienteData}>{fija.edificio}</td>
                  <td className={styles.buildingComisionData}>{formatCurrency(fija.montoLocal)}</td>
                </tr>
              ))}
          </tbody>
          <tfoot>
            <tr className={styles.modalTotal} style={{ borderTop: "3px solid #333" }}>
              <td colSpan="2" style={{ textAlign: "left" }}>
                <strong>Total</strong>
              </td>
              <td className={styles.buildingComisionData}>
                <strong>{formatCurrency(totalGeneral)}</strong>
              </td>
            </tr>
          </tfoot>
        </table>
        <div className={styles.modalActions}>
          <button className={styles.btnClose} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
